import { AnalyticEvent } from "../AnalyticEvent";


const EVENT_NAME = "PageLoaded"
export class PageLoadedEvent extends AnalyticEvent {

    constructor(pageName:string){
        super(EVENT_NAME, {"page":pageName});
    }
}